import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const EnterpriseGradeSecurityIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.87868 11.3787C4.44129 10.8161 5.20435 10.5 6 10.5H18C18.7956 10.5 19.5587 10.8161 20.1213 11.3787C20.6839 11.9413 21 12.7044 21 13.5V21C21 21.7956 20.6839 22.5587 20.1213 23.1213C19.5587 23.6839 18.7956 24 18 24H6C5.20435 24 4.44129 23.6839 3.87868 23.1213C3.31607 22.5587 3 21.7956 3 21V13.5C3 12.7044 3.31607 11.9413 3.87868 11.3787ZM6 12C5.60218 12 5.22064 12.158 4.93934 12.4393C4.65804 12.7206 4.5 13.1022 4.5 13.5V21C4.5 21.3978 4.65804 21.7794 4.93934 22.0607C5.22064 22.342 5.60218 22.5 6 22.5H18C18.3978 22.5 18.7794 22.342 19.0607 22.0607C19.342 21.7794 19.5 21.3978 19.5 21V13.5C19.5 13.1022 19.342 12.7206 19.0607 12.4393C18.7794 12.158 18.3978 12 18 12H6Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.5C10.8065 1.5 9.66193 1.97411 8.81802 2.81802C7.97411 3.66193 7.5 4.80653 7.5 6V11.25C7.5 11.6642 7.16421 12 6.75 12C6.33579 12 6 11.6642 6 11.25V6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0C13.5913 0 15.1174 0.632141 16.2426 1.75736C17.3679 2.88258 18 4.4087 18 6V11.25C18 11.6642 17.6642 12 17.25 12C16.8358 12 16.5 11.6642 16.5 11.25V6C16.5 4.80653 16.0259 3.66193 15.182 2.81802C14.3381 1.97411 13.1935 1.5 12 1.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 14.625C7.59946 14.625 7.69484 14.5855 7.76517 14.5152C7.83549 14.4448 7.875 14.3495 7.875 14.25C7.875 14.1505 7.83549 14.0552 7.76517 13.9848C7.69484 13.9145 7.59946 13.875 7.5 13.875V13.125C7.20163 13.125 6.91548 13.2435 6.70451 13.4545C6.49353 13.6655 6.375 13.9516 6.375 14.25C6.375 14.5484 6.49353 14.8345 6.70451 15.0455C6.91548 15.2565 7.20163 15.375 7.5 15.375V14.625Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 13.125C7.79837 13.125 8.08452 13.2435 8.29549 13.4545C8.50647 13.6655 8.625 13.9516 8.625 14.25C8.625 14.5484 8.50647 14.8345 8.29549 15.0455C8.08452 15.2565 7.79837 15.375 7.5 15.375V14.625C7.40054 14.625 7.30516 14.5855 7.23483 14.5152C7.16451 14.4448 7.125 14.3495 7.125 14.25C7.125 14.1505 7.16451 14.0552 7.23483 13.9848C7.30516 13.9145 7.40054 13.875 7.5 13.875V13.125Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  })
);
